import { AfterViewInit, ChangeDetectorRef, Component, inject, Input, OnInit, QueryList, ViewChildren } from "@angular/core";
import { UntilDestroy } from "@ngneat/until-destroy";
import { LogService } from "@nts/std/utility";
import { RootModelTypeNameInspector } from "../../api-clients/decorators/root-model-type-name.decorator";
import { ExpandableComponent } from "../shared/expandable/expandable.component";
import type { CoreOrchestratorViewModelInterface, LayoutDefinitionIdentityInterface, RootViewModelInterface, ViewComponentInterface } from '@nts/std/interfaces';
import { Subject } from "rxjs";

@UntilDestroy()
@Component({
    template: '',
    standalone: true,
})
export abstract class BaseAggregateComponent<
    TRootViewModel extends RootViewModelInterface,
    TOrchestratorViewModel extends CoreOrchestratorViewModelInterface = CoreOrchestratorViewModelInterface
> implements ViewComponentInterface<RootViewModelInterface>, OnInit, AfterViewInit {
    @Input() orchestratorViewModel: TOrchestratorViewModel;
    @ViewChildren(ExpandableComponent) expandableComponentList: QueryList<ExpandableComponent>;

    /**
     * Viene impostata solo quando si è in un layout personalizzato
     */
    layoutIdentity?: LayoutDefinitionIdentityInterface;
    afterViewInit$ = new Subject<void>();

    public changeDetectorRef = inject(ChangeDetectorRef);

    get rootViewModel(): TRootViewModel {
        return this.orchestratorViewModel.rootViewModel as TRootViewModel;
    }

    ngOnInit() {
        LogService.log(RootModelTypeNameInspector.getValue(this.orchestratorViewModel.apiClient) + ' - INIT');
    }

    /**
     * @deprecated onViewModelLoaded è deprecato, se è necessario utilizzare il ChangeDetectorRef, usarlo dall'orchestrator
     */
    onViewModelLoaded() {
    }

    ngAfterViewInit(): void {
        this.afterViewInit$.next();
    }
}
